import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { UpdatePaymentApiLoginInfoRequestModel, UpdatePaymentApiLoginInfoResponseModel } from "@/features/accounts/payment/api/services/update-login-info-model";

export class UpdatePaymentApiLoginInfoApi {
  /**
   * MoneyLook ログイン情報更新認可開始画面要求（API版）API
   */
  public updatePaymentApiLoginInfo = async (
    param: UpdatePaymentApiLoginInfoRequestModel
  ): Promise<UpdatePaymentApiLoginInfoResponseModel> => {
    const path = `/api/paymentaccounts/api/updatelogininfo`;
    const res = await ApiClient.instance.get<UpdatePaymentApiLoginInfoResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
